// Manual route configuration
// This file contains manually defined route names for better control and readability

export interface RouteConfig {
  default: string
  gokollab?: string
  communities?: string
  courses?: string
  requiredParams: string[]
}

export const routeConfig: Record<string, RouteConfig> = {
  // Communities Routes
  'communities-groups-about': {
    default: '/communities/groups/[groupSlug]/about',
    gokollab: '/[groupSlug]/about',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-channel': {
    default: '/communities/groups/[groupSlug]/channels/[channelSlug]',
    gokollab: '/[groupSlug]/channels/[channelSlug]',
    requiredParams: ['groupSlug', 'channelSlug'],
  },

  'communities-groups-conversations': {
    default: '/communities/groups/[groupSlug]/conversations',
    gokollab: '/[groupSlug]/conversations',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-content-unavailable': {
    default: '/communities/groups/[groupSlug]/content-unavailable',
    gokollab: '/[groupSlug]/content-unavailable',
    requiredParams: ['groupSlug'],
  },

  'communities-conversations': {
    default: '/communities/conversations',
    gokollab: '/conversations',
    requiredParams: [],
  },

  'communities-conversations-conversationId': {
    default: '/communities/conversations/[conversationId]',
    gokollab: '/conversations/[conversationId]',
    requiredParams: ['conversationId'],
  },

  'communities-groups-channel-post': {
    default: '/communities/groups/[groupSlug]/channels/[channelSlug]/posts/[postId]',
    gokollab: '/[groupSlug]/channels/[channelSlug]/posts/[postId]',
    requiredParams: ['groupSlug', 'channelSlug', 'postId'],
  },

  'communities-groups-events': {
    default: '/communities/groups/[groupSlug]/events',
    gokollab: '/[groupSlug]/events',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-home': {
    default: '/communities/groups/[groupSlug]/home',
    gokollab: '/[groupSlug]/home',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-home-post': {
    default: '/communities/groups/[groupSlug]/home/posts/[postId]',
    gokollab: '/[groupSlug]/home/posts/[postId]',
    requiredParams: ['groupSlug', 'postId'],
  },

  'communities-groups-leaderboard': {
    default: '/communities/groups/[groupSlug]/leaderboard',
    gokollab: '/[groupSlug]/leaderboard',
    requiredParams: ['groupSlug'],
  },

  //   'communities-groups-learning-courses-lesson': {
  //     default: '/communities/groups/[groupSlug]/learning/courses/[productId]/lesson/[postId]',
  //     gokollab: '/[groupSlug]/learning/courses/[productId]/lesson/[postId]',
  //     requiredParams: ['groupSlug', 'productId', 'postId'],
  //   },

  'communities-groups-learning': {
    default: '/communities/groups/[groupSlug]/learning',
    gokollab: '/[groupSlug]/learning',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-members': {
    default: '/communities/groups/[groupSlug]/members',
    gokollab: '/[groupSlug]/members',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings': {
    default: '/communities/groups/[groupSlug]/settings',
    gokollab: '/[groupSlug]/settings',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-appearance': {
    default: '/communities/groups/[groupSlug]/settings/appearance',
    gokollab: '/[groupSlug]/settings/appearance',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-branding': {
    default: '/communities/groups/[groupSlug]/settings/branding',
    gokollab: '/[groupSlug]/settings/branding',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-details': {
    default: '/communities/groups/[groupSlug]/settings/details',
    gokollab: '/[groupSlug]/settings/details',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-discovery': {
    default: '/communities/groups/[groupSlug]/settings/discovery',
    gokollab: '/[groupSlug]/settings/discovery',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-gamification-rewards': {
    default: '/communities/groups/[groupSlug]/settings/gamification-rewards',
    gokollab: '/[groupSlug]/settings/gamification-rewards',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-membership-questions': {
    default: '/communities/groups/[groupSlug]/settings/membership-questions',
    gokollab: '/[groupSlug]/settings/membership-questions',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-promotional-links': {
    default: '/communities/groups/[groupSlug]/settings/promotional-links',
    gokollab: '/[groupSlug]/settings/promotional-links',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-reported-content': {
    default: '/communities/groups/[groupSlug]/settings/reported-content',
    gokollab: '/[groupSlug]/settings/reported-content',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-import-skool-content': {
    default: '/communities/groups/[groupSlug]/settings/import-skool-content',
    gokollab: '/[groupSlug]/settings/import-skool-content',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-subscriptions': {
    default: '/communities/groups/[groupSlug]/settings/subscriptions',
    gokollab: '/[groupSlug]/settings/subscriptions',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-newsletter': {
    default: '/communities/groups/[groupSlug]/settings/newsletter',
    gokollab: '/[groupSlug]/settings/newsletter',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-community-tabs': {
    default: '/communities/groups/[groupSlug]/settings/community-tabs',
    gokollab: '/[groupSlug]/settings/community-tabs',
    requiredParams: ['groupSlug'],
  },

  'communities-groups-settings-analytics': {
    default: '/communities/groups/[groupSlug]/settings/analytics',
    gokollab: '/[groupSlug]/settings/analytics',
    requiredParams: ['groupSlug'],
  },

  'communities-groups': {
    default: '/communities/groups',
    gokollab: '/',
    requiredParams: [],
  },

  communities: {
    default: '/communities',
    gokollab: '/',
    requiredParams: [],
  },

  'communities-user': {
    default: '/communities/users/[userSlug]',
    gokollab: '/users/[userSlug]',
    requiredParams: ['userSlug'],
  },

  'communities-user-communities': {
    default: '/communities/users/[userSlug]/communities',
    gokollab: '/users/[userSlug]/communities',
    requiredParams: ['userSlug'],
  },
  'communities-user-contributions': {
    default: '/communities/users/[userSlug]/contributions',
    gokollab: '/users/[userSlug]/contributions',
    requiredParams: ['userSlug'],
  },

  'communities-user-post': {
    default: '/communities/users/[userSlug]/contributions/posts/[postId]',
    gokollab: '/users/[userSlug]/contributions/posts/[postId]',
    requiredParams: ['userSlug', 'postId'],
  },

  // Courses Routes
  courses: {
    default: '/courses',
    requiredParams: [],
  },

  'courses-products-modules-lessons': {
    default: '/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId]',
    communities: '/communities/groups/[groupSlug]/learning/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId]',
    requiredParams: ['productId', 'moduleId', 'lessonId'],
  },

  /** Legacy standalone courses URL shape (e.g. production external handoff). SPA redirects to modules/lessons in this app. */
  'courses-products-categories-posts': {
    default: '/courses/products/[productId]/categories/[moduleId]/posts/[lessonId]',
    requiredParams: ['productId', 'moduleId', 'lessonId'],
  },

  'courses-products-modules-lessons-new': {
    default: '/courses/products/[productId]/modules/[moduleId]/lessons/new/[lessonId]',
    requiredParams: ['productId', 'moduleId', 'lessonId'],
  },

  'courses-purchase-product': {
    default: '/courses/products/[productId]/purchase-course',
    gokollab: '/[groupSlug]/learning/courses/products/[productId]/purchase',
    communities: '/communities/groups/[groupSlug]/learning/courses/products/[productId]/purchase',
    requiredParams: ['productId'],
  },

  'courses-checkout': {
    default: '/courses/[productId]',
    communities: '/communities/groups/[groupSlug]/learning/courses/[productId]',
    // requiredParams only lists productId because callers that want the standalone URL use getDefaultTemplate=true.
    // When navigating from a communities context without getDefaultTemplate, pass groupSlug or the URL will contain the literal [groupSlug].
    requiredParams: ['productId'],
  },

  'courses-back': {
    default: '/courses',
    gokollab: '',
    communities: '/communities/groups/[groupSlug]/learning',
    requiredParams: [],
  },

  'courses-products': {
    default: '/courses/products/[productId]',
    communities: '/communities/groups/[groupSlug]/learning/courses/[productId]',
    requiredParams: ['productId'],
  },

  'courses-products-live-sessions': {
    default: '/courses/products/[productId]/live-sessions',
    communities: '/communities/groups/[groupSlug]/learning/courses/products/[productId]/live-sessions',
    requiredParams: ['productId'],
  },

  'courses-products-new': {
    default: '/courses/products/new/[productId]',
    requiredParams: ['productId'],
  },

  'courses-category': {
    default: '/courses/category/[categorySlug]',
    requiredParams: ['categorySlug'],
  },

  'courses-search': {
    default: '/courses/search',
    requiredParams: [],
  },

  'courses-announcements': {
    default: '/courses/announcements',
    requiredParams: [],
  },

  'courses-announcements-detail': {
    default: '/courses/announcements/[id]',
    requiredParams: ['id'],
  },

  'my-library': {
    default: '/courses/my-library',
    communities: '/communities/my-library',
    gokollab: '/courses/my-library',
    requiredParams: [],
  },

  // GoKollab Routes
  'gokollab-about': {
    default: '/about',
    gokollab: '/about',
    requiredParams: [],
  },

  'gokollab-contact': {
    default: '/contact',
    gokollab: '/contact',
    requiredParams: [],
  },

  'gokollab-privacy': {
    default: '/privacy',
    gokollab: '/privacy',
    requiredParams: [],
  },

  'gokollab-community-category': {
    default: '/community/[categorySlug]',
    requiredParams: ['categorySlug'],
  },

  'gokollab-courses-category': {
    default: '/course/[categorySlug]',
    requiredParams: ['categorySlug'],
  },

  'gokollab-community-search': {
    default: '/community/[categorySlug]/search',
    requiredParams: ['categorySlug'],
  },

  'gokollab-courses-search': {
    default: '/course/[categorySlug]/search',
    requiredParams: ['categorySlug'],
  },

  'gokollab-search-input': {
    default: '/search-input',
    requiredParams: [],
  },

  'gokollab-creators-category': {
    default: '/creator/[categorySlug]',
    requiredParams: ['categorySlug'],
  },

  'gokollab-create-community': {
    default: '/create/community',
    requiredParams: [],
  },

  'gokollab-create-course': {
    default: '/create/course',
    requiredParams: [],
  },

  'gokollab-onboarding': {
    default: '/onboarding',
    requiredParams: [],
  },

  'manage-course-content': {
    default: '/manage/course/content',
    requiredParams: [],
  },

  about: {
    default: '/about',
    gokollab: '/about',
    requiredParams: [],
  },

  privacy: {
    default: '/privacy',
    gokollab: '/privacy',
    requiredParams: [],
  },

  contact: {
    default: '/contact',
    gokollab: '/contact',
    requiredParams: [],
  },

  pricing: {
    default: '/pricing',
    gokollab: '/pricing',
    requiredParams: [],
  },

  'pricing-compare': {
    default: '/pricing-compare',
    gokollab: '/pricing-compare',
    requiredParams: [],
  },

  'my-plan': {
    default: '/my-plan',
    gokollab: '/my-plan',
    requiredParams: [],
  },

  // Creator bio only — discovery creator browse is `gokollab-creators-category` (feat/discover_page).
  'gokollab-creator-profile': {
    default: '/creators/[creatorSlug]',
    gokollab: '/creators/[creatorSlug]',
    requiredParams: ['creatorSlug'],
  },

  /** Discovery listing about — preview parity path; resolves via communities-groups-about or courses-checkout. */
  'gokollab-listing-about': {
    default: '/about/[slug]',
    gokollab: '/about/[slug]',
    requiredParams: ['slug'],
  },

  index: {
    default: '/',
    communities: '/communities',
    courses: '/courses',
    gokollab: '/',
    requiredParams: [],
  },

  // Account Settings - Standalone route accessible from all apps
  'account-settings': {
    default: '/account',
    communities: '/account',
    courses: '/account',
    gokollab: '/account',
    requiredParams: [],
  },

  // ClientPortal Routes
  'clientportal-dashboard': {
    default: '/dashboard',
    requiredParams: [],
  },

  'clientportal-courses': {
    default: '/courses',
    requiredParams: [],
  },

  'clientportal-courses-offer-checkout': {
    default: '/courses/offers/[offerId]',
    requiredParams: ['offerId'],
  },

  // Course Default Pricing checkout link — same remote CheckoutPage as the offer
  // checkout, distinct path so the course pricing share link reads as a checkout.
  'clientportal-courses-checkout': {
    default: '/courses/checkout/[offerId]',
    requiredParams: ['offerId'],
  },

  'clientportal-courses-one-click-upsell': {
    default: '/courses/upsell-offers/one-click/[upsellId]',
    requiredParams: ['upsellId'],
  },

  'clientportal-courses-my-courses': {
    default: '/courses/my-courses',
    requiredParams: [],
  },

  'clientportal-courses-discover': {
    default: '/courses/discover',
    requiredParams: [],
  },

  /** Protected compatibility entry point retained for existing Client Portal bookmarks and shared links. */
  'clientportal-courses-bundle': {
    default: '/courses/bundles/[bundleOfferId]',
    requiredParams: ['bundleOfferId'],
  },

  /** Canonical authenticated in-app upsell checkout route in the Client Portal SPA. */
  'courses-upsell-offers-in-app-bundle': {
    default: '/courses/upsell-offers/in-app/[bundleOfferId]',
    requiredParams: ['bundleOfferId'],
  },

  'clientportal-communities': {
    default: '/communities',
    requiredParams: [],
  },

  'clientportal-communities-my-communities': {
    default: '/communities/my-communities',
    requiredParams: [],
  },

  'clientportal-communities-discover': {
    default: '/communities/discover',
    requiredParams: [],
  },

  'clientportal-shared-files': {
    default: '/shared-files',
    requiredParams: [],
  },

  'clientportal-invoices': {
    default: '/invoices',
    requiredParams: [],
  },

  'clientportal-estimates': {
    default: '/estimates',
    requiredParams: [],
  },

  'clientportal-contracts': {
    default: '/contracts',
    requiredParams: [],
  },

  'clientportal-appointments': {
    default: '/appointments',
    requiredParams: [],
  },

  'clientportal-events': {
    default: '/events',
    requiredParams: [],
  },

  'clientportal-events-live': {
    default: '/events/live',
    requiredParams: [],
  },

  'clientportal-events-upcoming': {
    default: '/events/upcoming',
    requiredParams: [],
  },

  'clientportal-events-past': {
    default: '/events/past',
    requiredParams: [],
  },

  'clientportal-events-detail': {
    default: '/events/[eventId]',
    requiredParams: ['eventId'],
  },

  'clientportal-appointments-book': {
    default: '/appointments/book',
    requiredParams: [],
  },

  'clientportal-affiliates': {
    default: '/affiliates',
    requiredParams: [],
  },

  'clientportal-affiliates-campaign': {
    default: '/affiliates/campaign',
    requiredParams: [],
  },
  'clientportal-affiliates-sub-affiliate': {
    default: '/affiliates/sub-affiliate',
    requiredParams: [],
  },
  'clientportal-affiliates-lead': {
    default: '/affiliates/lead',
    requiredParams: [],
  },
  'clientportal-affiliates-commission': {
    default: '/affiliates/commission',
    requiredParams: [],
  },
  'clientportal-affiliates-payout-methods': {
    default: '/affiliates/payout-methods',
    requiredParams: [],
  },
  'clientportal-affiliates-media': {
    default: '/affiliates/media',
    requiredParams: [],
  },
  'clientportal-affiliates-media-folder': {
    default: '/affiliates/media/folder/[folderId]',
    requiredParams: ['folderId'],
  },

  // Auth Routes
  'auth-login': {
    default: '/login',
    requiredParams: [],
  },

  'auth-signup': {
    default: '/signup',
    requiredParams: [],
  },

  'auth-forgot-password': {
    default: '/forgot-password',
    requiredParams: [],
  },

  'auth-login-with-code': {
    default: '/login-with-code',
    requiredParams: [],
  },

  'auth-set-password': {
    default: '/set-password',
    requiredParams: [],
  },

  'auth-reset-password': {
    default: '/reset-password',
    requiredParams: [],
  },

  'auth-expired-password': {
    default: '/expired-password',
    requiredParams: [],
  },

  'auth-profile-confirmation': {
    default: '/profile-confirmation',
    requiredParams: [],
  },

  auth: {
    default: '/auth',
    requiredParams: [],
  },

  // Studio Routes
  'gokollab-studio': {
    default: '/studio',
    gokollab: '/studio',
    requiredParams: [],
  },

  // Meet Routes (name must match usage in apps/meet when using CPNavigateTo)
  'meet-licenseId': {
    default: '/meet/[licenseId]',
    requiredParams: ['licenseId'],
  },

  'meet-recordings': {
    default: '/meet/recordings',
    requiredParams: [],
  },

  'manage-purchases': {
    default: '/manage/purchases',
    gokollab: '/manage/purchases',
    requiredParams: [],
  },
}

export type RouteName = keyof typeof routeConfig
